import { FastField } from "formik";
import { memo, useMemo } from "react";
import moment from "moment";
import { FormikSelect, fastFieldShouldUpdate } from "@accessinformatica/formik-mui";
import FormikDateTimePicker from "../../../commons/formik/formikDateTimePicker";
import DeferredFormikTextField from "./deferredFormikTextField";
import FormikActions from "../../../commons/formik/formikActions";
import { StyledCommonForms } from "../../../styled/form";
import DropZone from "../dropZone/dropZone";
import FormSectionDivider from "../formSectionDivider";
import {
  catalogSelectMenuItems,
  mapCatalogToOptions,
} from "./catalogMenuItems.jsx";
const DirectionsSlot = ({ renderDirections }) =>
  renderDirections ? renderDirections() : null;

const TrasladoExtrasSlot = memo(({ renderTrasladoExtras }) =>
  renderTrasladoExtras ? renderTrasladoExtras() : null,
);

const FptTrasladosFormContent = memo(function FptTrasladosFormContent({
    attachmentError,
    disableDateUpdate,
    disabled,
    fechaHoraSolicitudMinDate,
    fields,
    files,
    handleClose,
    model,
    renderDirections,
    renderTrasladoExtras,
    selectedDocument,
    setAttachmentError,
    setFiles,
  }) {
    const tipoUrgenciaItems = useMemo(
      () =>
        catalogSelectMenuItems(
          mapCatalogToOptions(fields.tipoUrgenciaNombre.options),
          false,
        ),
      [fields.tipoUrgenciaNombre.options],
    );

    return (
    <StyledCommonForms.FormContainer>
      <StyledCommonForms.FieldContainer>
        <FormSectionDivider title="Traslado" />
        <StyledCommonForms.RowContainer>
          <StyledCommonForms.LeftColumnContainer>
            <FormikDateTimePicker
              autoComplete="off"
              disableFuture
              disabled={disabled || disableDateUpdate}
              label={`Solicitado el ${fields.fechaHoraSolicitud.required ? "*" : ""}`}
              minDate={fechaHoraSolicitudMinDate}
              name="fechaHoraSolicitud"
              sx={StyledCommonForms.input}
              variant="outlined"
            />
          </StyledCommonForms.LeftColumnContainer>
          <StyledCommonForms.RightColumnContainer>
            <FastField
              name="fechaHoraTurno"
              shouldUpdate={(nextProps, currentProps) =>
                fastFieldShouldUpdate(nextProps, currentProps) ||
                nextProps.formik.values.idTipoTraslado !==
                  currentProps.formik.values.idTipoTraslado ||
                nextProps.formik.values.fechaHoraSolicitud !==
                  currentProps.formik.values.fechaHoraSolicitud
              }>
              {({ form }) => {
                const isEnElDia =
                  String(form.values.idTipoTraslado) === "1" ||
                  String(form.values.idTipoTraslado)
                    ?.toLowerCase?.()
                    .includes("día") ||
                  String(form.values.idTipoTraslado)
                    ?.toLowerCase?.()
                    .includes("dia");
                const maxDate = isEnElDia
                  ? moment().endOf("day").toDate()
                  : undefined;
                return (
                  <FormikDateTimePicker
                    autoComplete="off"
                    disabled={disabled || disableDateUpdate}
                    label={`Para el ${fields.fechaHoraTurno.required ? "*" : ""}`}
                    minDate={form.values.fechaHoraSolicitud || undefined}
                    maxDate={maxDate}
                    name="fechaHoraTurno"
                    sx={StyledCommonForms.input}
                    variant="outlined"
                  />
                );
              }}
            </FastField>
          </StyledCommonForms.RightColumnContainer>
        </StyledCommonForms.RowContainer>
        <StyledCommonForms.RowContainer>
          <StyledCommonForms.LeftColumnContainer>
            <FormikSelect
              disabled={disabled}
              label={`Tipo de urgencia ${fields.tipoUrgenciaNombre.required ? "*" : ""}`}
              name="tipoUrgenciaNombre"
              sx={StyledCommonForms.input}
              fullWidth
              variant="outlined">
              {tipoUrgenciaItems}
            </FormikSelect>
          </StyledCommonForms.LeftColumnContainer>
        </StyledCommonForms.RowContainer>
        <TrasladoExtrasSlot renderTrasladoExtras={renderTrasladoExtras} />
        <StyledCommonForms.RowContainer>
          <DeferredFormikTextField
            disabled={disabled}
            id="observaciones"
            label={`Observaciones ${fields.observaciones.required ? "*" : ""}`}
            minRows={3}
            multiline
            name="observaciones"
            sx={StyledCommonForms.input}
            type="text"
            variant="outlined"
          />
        </StyledCommonForms.RowContainer>
        <DirectionsSlot renderDirections={renderDirections} />
        {model.configuration.showAttachments && (
          <div>
            <FormSectionDivider title="Adjuntos" />
            <StyledCommonForms.RowContainer>
              <DropZone
                accept={model.configuration.availableExtensions}
                configuration={model.configuration}
                disabled={disabled}
                error={attachmentError}
                files={files}
                selectedDocument={selectedDocument}
                setError={setAttachmentError}
                setFiles={setFiles}
              />
            </StyledCommonForms.RowContainer>
          </div>
        )}
      </StyledCommonForms.FieldContainer>
      <StyledCommonForms.ActionsContainer>
        <FormikActions disabled={disabled} handleCancel={handleClose} />
      </StyledCommonForms.ActionsContainer>
    </StyledCommonForms.FormContainer>
    );
  },
);

FptTrasladosFormContent.displayName = "FptTrasladosFormContent";

export default FptTrasladosFormContent;
